import React from "react"

import Cashier from '@/pages/cashier'
import Page from "@/pages/default"
import usePay from "@/store/payment"

import { Redirect, Route, BrowserRouter as Router, Switch } from "react-router-dom"

export default () => {
    const { order: { status, time_expire, }, _404 } = usePay(s => ({ order: s.order, _404: s._404 }))
    let t = window.location.pathname.split("/")

    return (
        <Router>
            <React.Suspense fallback={null}>
                {_404 && <Redirect to="/404"></Redirect>}
                <Switch>
                    {status && status === "TO-BE-PAID" && time_expire > Date.now() / 1000 && !window.location.pathname.includes("/cashier/") && <Redirect to={"/cashier/" + t[t.length - 1]}></Redirect>}
                    <Route
                        exact
                        path="/404"
                        component={require("@/pages/404").default}
                    />
                    <Route
                        path="/:id"
                        exact
                        component={Page}
                    />
                    <Route
                        exact
                        path="/cashier/:id"
                        component={Cashier}
                    />
                    <Route
                        path="/"
                        render={() => {
                            return <Redirect to="/404"></Redirect>
                        }}></Route>
                </Switch>
            </React.Suspense>
        </Router>
    )
}
